import { useCallback, useEffect, useRef, useState } from 'react';
import './checkout.scss'
import EventBus from '../../utils/EventBus';
import cartMaganer from '../../manager/cart';
import orderManager from '../../manager/order';
import util, { navigateTo } from '../../utils/util';
import { toast } from '../../utils/toast';
import Block from '../../components/Base/Block';
import View from '../../components/Base/View';
import Text from '../../components/Base/Text';
import Image from '../../components/Base/Image';
import { Button, Form, Input } from 'antd';
import Price from '../../components/Price';
import addressManager from '../../manager/address';
import Productinfoinorder from '../../components/ProductInfoInOrder';
import Modal, { ModalRef } from '../../components/Modal';
import Picker from '../../components/Base/Picker';
import CouponChoosePannel from '../../components/CouponChoosePannel';
import rm from '../../utils/rm';
import PayOrderPanel, { PayOrderPanelRef } from '../../components/PayOrderPanel';
import tool from '../../utils/addressUtil';

const Checkout = () => {

    const [ids, setIds] = useState<number[]>([]);    //结算的购物车ID数组
    const [reorderId, setReorderId] = useState<number>(0);  //再次购买原订单ID
    const [ShippingAddress, setShippingAddress] = useState<any>()
    const [selectCoupon, setSelectCoupon] = useState<any>(); //选中的优惠券

    const [userCoin, setUserCoin] = useState<boolean>(false);    //是否使用金币
    const [coinIndex, setCoinIndex] = useState<number>(-1); //消费的金币数量索引
    const [RewardPoint, setRewardPoint] = useState<{
        _selectCoinArray: number[],
        _MaxUseableCoinNum: number,
        _MaxDiscountRMB: number,
        CustomerCount: number,
        ExchangeRate: number,
        DisplayHowMuchWillBeEarned: boolean,
        Rules: any[]
    }>()

    const [ShoppingCartItems, setShoppingCartItems] = useState<any[]>([])
    const [Discounts, setDiscounts] = useState<any[]>([])
    const [OrderTotals, setOrderTotals] = useState<any>()
    const [CustomerWxOpenIdObtained, setCustomerWxOpenIdObtained] = useState<any>()

    const [orderInfo, setOrderInfo] = useState<any>()

    const [discountValid, setDiscountValid] = useState<any[]>([]); // 可用优惠券
    const [discountInvalid, setDiscountInvalid] = useState<any[]>([]); // 不可用优惠券

    const [orderNote, setOrderNote] = useState<string>('');
    const [AddressError, setAddressError] = useState<string>('');
    const [isCoinRuleModalOpen, setIsCoinRuleModalOpen] = useState<boolean>(false);

    const payOrderRef = useRef<PayOrderPanelRef>()

    const coinRuleModal = useRef<ModalRef>()


    const processCheckoutResult = useCallback((success: boolean, res: any, tips: string) => {
        console.log('结算结果：', res)
        toast.destory("order-checking")
        if (success) {
            var RewardPointInfo = res.data.Content.RewardPoint
            var selectCoinArray = []
            var minCoinCanUse = RewardPointInfo.MinimumRewardPointsToUse //最小可使用金币
            var maxCoinCanUse = RewardPointInfo.MaximumRewardPointsToUse //最大可使用金币
            var userTotalCoin = RewardPointInfo.CustomerCount //用户总金币数
            var realUserCoinNum = res.data.Content.OrderTotals.RedeemedRewardPoints //结算时实际使用的金币数量

            var lastPushValue = 0
            const isValiedValue = function (value: number) {
                // 满足条件：大于零、大于等于最小可用、
                return (
                    value != lastPushValue &&
                    value > 0 &&
                    value >= minCoinCanUse &&
                    value <= maxCoinCanUse &&
                    value <= userTotalCoin
                )
            }
            if (RewardPointInfo.CanUseRewardPoint) {
                //判断是否可以使用金币折扣

                // 最小
                if (isValiedValue(minCoinCanUse)) {
                    selectCoinArray.push(minCoinCanUse)
                    lastPushValue = minCoinCanUse
                }

                //各步长区间
                RewardPointInfo.RewardPointsToUseUnit.forEach(function (item: any) {
                    var value = item.Start
                    while (
                        value <= item.End &&
                        value >= item.Start &&
                        value <= maxCoinCanUse &&
                        value <= userTotalCoin
                    ) {
                        if (isValiedValue(value)) {
                            selectCoinArray.push(value)
                            lastPushValue = value
                        }
                        value += item.Unit
                        if (item.Unit <= 0) {
                            break
                        }
                    }
                })

                //最大
                if (isValiedValue(maxCoinCanUse)) {
                    selectCoinArray.push(maxCoinCanUse)
                    lastPushValue = maxCoinCanUse
                }

                //实际结算金币如果不在列表则添加进入
                if (
                    realUserCoinNum > 0 &&
                    selectCoinArray.indexOf(realUserCoinNum) == -1
                ) {
                    var insertIndex = selectCoinArray.findIndex((coinNum) => {
                        return coinNum > realUserCoinNum
                    })
                    if (insertIndex !== -1) {
                        selectCoinArray.splice(insertIndex, 0, realUserCoinNum)
                    } else {
                        selectCoinArray.push(realUserCoinNum)
                    }
                }
            }

            var realUserCoinNumIndex = -1 //结算时实际使用的金币数量在可用列表中的索引
            var maxUseableCoinNum = 0 //用户此订单最大可用金币数
            if (selectCoinArray.length > 0) {
                realUserCoinNumIndex = selectCoinArray.findIndex((num) => {
                    return num == realUserCoinNum
                })
                maxUseableCoinNum = selectCoinArray[selectCoinArray.length - 1]
            }


            setShippingAddress(((pre: any) => {
                if (!pre || pre.Id !== res.data.Content.ShippingAddress?.Id) {
                    return res.data.Content.ShippingAddress
                }
                return pre;
            }))
            setShoppingCartItems(res.data.Content.ShoppingCartItems)
            setDiscounts(res.data.Content.Discounts)
            setOrderTotals(res.data.Content.OrderTotals)

            RewardPointInfo._selectCoinArray = selectCoinArray
            RewardPointInfo._MaxUseableCoinNum = maxUseableCoinNum
            RewardPointInfo._MaxDiscountRMB = util.round(
                maxUseableCoinNum * RewardPointInfo.ExchangeRate,
                2
            )
            console.log("RewardPointInfo", RewardPointInfo)
            setRewardPoint((pre: any) => {
                if (!pre || pre._MaxUseableCoinNum !== RewardPointInfo._MaxUseableCoinNum) {
                    return RewardPointInfo;
                }
                return pre;
            })
            setCoinIndex(realUserCoinNumIndex < 0
                ? RewardPointInfo._selectCoinArray.length - 1
                : realUserCoinNumIndex)
            setUserCoin(realUserCoinNumIndex > -1)
            setCustomerWxOpenIdObtained(res.data.Content.CustomerWxOpenIdObtained)
            setAddressError(util.isEmpty(res.data.Content.AddressError)
                ? ''
                : res.data.Content.AddressError)

            setIds((pre: number[]) => {
                var cartItemIds = pre
                if (cartItemIds.length == 0) {
                    res.data.Content.ShoppingCartItems.forEach(function (item: any) {
                        cartItemIds.push(item.Id)
                    })
                }
                return cartItemIds;
            })


            //筛选出 可用、不可用 优惠券
            var discountValid: any[] = []
            var discountInvalid: any[] = []
            res.data.Content.Discounts.forEach(function (item: any) {
                if (item.IsValid) {
                    discountValid.push(item.Discount)
                } else {
                    discountInvalid.push(item.Discount)
                }
            })
            setDiscountValid(discountValid)
            setDiscountInvalid(discountInvalid)

        } else {
            toast.error(tips)

            // 结算错误需要重置下金币使用状态
            var realUserCoinNum = res.data.Content.OrderTotals.RedeemedRewardPoints //结算时实际使用的金币数量
            var realUserCoinNumIndex = -1
            if (realUserCoinNum > 0) {
                realUserCoinNumIndex = RewardPointInfo._selectCoinArray.findIndex(
                    (num: number) => {
                        return num == realUserCoinNum
                    }
                )
            }
            setCoinIndex(realUserCoinNumIndex < 0
                ? RewardPointInfo._selectCoinArray.length - 1
                : realUserCoinNumIndex)
            setUserCoin(realUserCoinNumIndex > -1)
        }
    }, [])


    // 结算
    useEffect(() => {
        toast.loading("结算中", 0, "order-checking")
        console.log("useEffect", [ids, reorderId, selectCoupon?.Id, userCoin && RewardPoint && coinIndex >= 0
            ? RewardPoint._selectCoinArray[coinIndex]
            : 0, ShippingAddress?.Id])
        if (ids.length > 0) {
            cartMaganer.checkout(
                {
                    Ids: ids,
                    couponId: selectCoupon?.Id || 0,
                    RewardPointsToUse:
                        userCoin && RewardPoint && coinIndex >= 0
                            ? RewardPoint._selectCoinArray[coinIndex]
                            : 0,
                },
                ShippingAddress?.Id || 0,
                processCheckoutResult
            )
        } else if (reorderId > 0) {
            orderManager.reorder(reorderId, processCheckoutResult)
        }
    }, [ids, reorderId, selectCoupon?.Id, userCoin && RewardPoint && coinIndex >= 0
        ? RewardPoint._selectCoinArray[coinIndex]
        : 0, ShippingAddress?.Id])


    useEffect(() => {
        document.title = "订单确认";
        const onAddressSelected = (addressInfo: any) => {
            setShippingAddress((pre: any) => {
                if (!pre || pre.Id !== addressInfo.Id) {
                    return addressInfo
                }
                return pre;
            })
        }
        const onAddressChanged = (result: {
            success: boolean,
            additional: {
                refreshReason: 'addNew' | 'edit' | 'delete' | 'getList' | 'init' | 'select',
                id: number,
            },
            res: any,
            tips: string,
        }) => {
            console.log("onAddressChanged", result)
            const newAddressList = result.res?.data?.Content?.Addresses || [];

            setShippingAddress((pre: any) => {
                let selectAdddressId = pre?.Id;
                if (result.additional?.refreshReason === 'select') {
                    selectAdddressId = result.additional.id;
                }
                let findAddress = undefined;
                if (newAddressList.length > 0) {
                    if (!selectAdddressId) {
                        selectAdddressId = newAddressList[0].Id;
                    }
                    if (selectAdddressId) {
                        findAddress = newAddressList.find((i: any) => i.Id === selectAdddressId)
                    }
                }
                return findAddress
            })

            setTimeout(() => {
                if (result.additional?.refreshReason === 'init') {
                    // 获取地址后
                    const urlInfo = util.parasUrl(window.location.href);
                    const idsStr = (urlInfo.params as any).ids;
                    const reorderIdStr = (urlInfo.params as any).reorderid;
                    console.log("idsStr", idsStr)
                    if (idsStr) {
                        setIds((pre: number[]) => {
                            const newIds = pre.length > 0 ? pre : (`${idsStr}` as string).split(",").map(i => parseInt(i));
                            console.log("newIds", newIds)
                            return newIds;

                        })
                    } else if (reorderIdStr) {
                        setReorderId(parseInt(reorderIdStr))
                    }
                }
            }, 100)

        }

        EventBus.register(EventBus.names.ADDRESS_SELECTED, onAddressSelected)
        EventBus.register(EventBus.names.ADDRESS_LIST_GET, onAddressChanged)
        addressManager.getAddressList({
            refreshReason: "init"
        })
        return () => {
            EventBus.unregister(EventBus.names.ADDRESS_SELECTED, onAddressSelected);
            EventBus.unregister(EventBus.names.ADDRESS_LIST_GET, onAddressChanged)
        }
    }, [])


    /**
 * 选择收货地址
 */
    const selectAddress = function () {
        util.navigateTo('/address/list?isrmmp=1&hidemenu=1&fromcheckout=true')
    }
    /**
     * 添加收货地址
     */
    const addAddress = function () {
        util.navigateTo('/address/edit?isrmmp=1&hidemenu=1&fromcheckout=true')
    }

    const orderNoteInput = function (e: any) {
        setOrderNote(e.target.value)
    }


    const payOrder = (orderInfo: any) => {
        var payParam = {
            OrderId: orderInfo.OrderDetails.Id,
            PaymentMethodSystemName: orderInfo.PaymentMethods[0].SystemName,
            CustomerWxOpenIdObtained: CustomerWxOpenIdObtained,
            OrderInfo: orderInfo.OrderDetails,
        }
        // toast.loading('支付中', 0, "pay")
        console.log("payOrder", orderInfo)
        payOrderRef.current?.request(payParam, function (state: string, data: any, tips: string) {
            toast.destory("pay")
            if (state === 'cancel') {
                // 取消支付
            } else if (state === 'success') {
                // 支付成功
                toast.success(tips)
            } else {
                // 支付失败
                toast.error(tips)
            }
            console.log("orderInfo", orderInfo)
            rm.redirectTo({
                url:
                    '/order/order?id=' +
                    orderInfo.OrderDetails.Id +
                    '&checkstate=' +
                    (state === 'success' ? 1 : 0),
            })
        })
    }

    const placeAndPayOrder = () => {
        if (!util.allowClick()) {
            return
        }
        if (!util.isEmpty(AddressError)) {
            toast.warning(AddressError)
            return
        }
        toast.loading('正在下单', 0, "placeOrder")
        cartMaganer.placeOrder(
            {
                Ids: ids,
                couponId: selectCoupon?.Id | 0,
                orderNote: orderNote,
                RewardPointsToUse: userCoin && RewardPoint
                    ? RewardPoint._selectCoinArray[coinIndex]
                    : 0,
            },
            ShippingAddress?.Id || 0,
            function (success: boolean, res: any, tips: string) {
                console.log('下单结果：', res)
                toast.destory("placeOrder")
                if (success) {
                    setOrderInfo(res.data.Content)
                    payOrder(res.data.Content)
                } else {
                    toast.error(tips)
                }
            }
        )
    }

    return <View className='checkout-page'>
        {/*  用户信息、送货地址  */}
        {OrderTotals?.RequiresShipping && (
            <View
                className="order-address flex-conainer"
                onClick={
                    !ShippingAddress || ShippingAddress?.Id <= 0
                        ? addAddress
                        : selectAddress
                }
            >
                <View className="flex-grow">
                    {!ShippingAddress || ShippingAddress?.Id <= 0 ? (
                        <Block>
                            <Text className="add-address-tips">点击添加收货地址</Text>
                        </Block>
                    ) : (
                        <Block>
                            <Text className="user-name">
                                {ShippingAddress.Name +
                                    '  ' +
                                    tool.getDisplayPhoneNumber(ShippingAddress.PhoneNumber)}
                            </Text>
                            <Text className="user-address">
                                {tool.getFullAddress(ShippingAddress)}
                            </Text>
                        </Block>
                    )}
                </View>
                <Image
                    className="setting-style-arrow"
                    src={require('../../images/right-arrow.png')}
                ></Image>
            </View>
        )}
        {OrderTotals?.RequiresShipping && (
            <View className="order-address-border"></View>
        )}
        {/*  商品信息  */}
        {ShoppingCartItems?.map((productInfo, index) => {
            return (
                <Block key={productInfo.Id}>
                    <Productinfoinorder
                        productInfo={productInfo}
                        fromPage="checkout"
                        clickToProductDetail={true}
                        showBottomBorder={
                            index != ShoppingCartItems?.length - 1
                        }
                    ></Productinfoinorder>
                </Block>
            )
        })}
        {/*  优惠券、发票  */}
        <View className="other-options setting-style-pannel">
            <View className="flex-conainer setting-style-item">
                <Text className="flex-fix">买家留言</Text>
                {!isCoinRuleModalOpen && (
                    <Input
                        className="flex-grow order-note"
                        onChange={orderNoteInput}
                        placeholder="填写内容需与商家协商并确认，发票请留言"
                    // placeholderClass="placeholder"
                    ></Input>
                )}
            </View>
            {/*  优惠券  */}
            <CouponChoosePannel
                discountValid={discountValid}
                discountInvalid={discountInvalid}
                onSelect={(coupon, isvalid) => {
                    if(isvalid){
                        setSelectCoupon(coupon)
                    }
                  
                }}
            >
                <View className="flex-conainer setting-style-item show-border">
                    <Text className="flex-grow">优惠券</Text>
                    <Text
                        className={
                            selectCoupon?.Id ? 'setting-style-value' : 'setting-style-des'
                        }
                    >
                        {selectCoupon?.Id > 0
                            ? selectCoupon.ShortName
                            : discountValid?.length > 0
                                ? discountValid?.length + ' 张优惠券可用'
                                : '无可用优惠券'}
                    </Text>
                    <Image
                        className="setting-style-arrow"
                        src={require('../../images/right-arrow.png')}
                    ></Image>
                </View>
            </CouponChoosePannel>
            {/*  金币折扣  */}
            {RewardPoint?._selectCoinArray && RewardPoint?._selectCoinArray?.length > 0 && (
                <View className="coin-item">
                    <Block>
                        <View className="coin-item-line">
                            <Text>
                                {'账户剩余 ' +
                                    RewardPoint?.CustomerCount +
                                    ' 金币，本单最多可用 ' +
                                    RewardPoint?._MaxUseableCoinNum +
                                    ' 金币，抵'}
                                <Text className="coin-price-value">
                                    {'¥' + RewardPoint?._MaxDiscountRMB}
                                </Text>
                            </Text>
                        </View>
                        {userCoin && (
                            <View className="coin-item-line">
                                <Text>选择使用</Text>
                                <Picker
                                    onChange={(value, index) => {
                                        var selectIndex = index
                                        if (coinIndex !== selectIndex) {
                                            setCoinIndex(selectIndex)
                                        }
                                    }}
                                    value={coinIndex}
                                    range={RewardPoint?._selectCoinArray}
                                >
                                    <View className="coin-select-btn">
                                        {coinIndex == -1
                                            ? 0
                                            : RewardPoint?._selectCoinArray?.[coinIndex]}
                                        <Image
                                            className="coin-select-icon"
                                            src={require('../../images/arrow-normal.png')}
                                        ></Image>
                                    </View>
                                </Picker>
                                <Text>金币，抵</Text>
                                <Text className="coin-price-value">
                                    {'¥' +
                                       tool. round(
                                            (coinIndex == -1
                                                ? 0
                                                : RewardPoint?._selectCoinArray?.[coinIndex]) *
                                            RewardPoint?.ExchangeRate,
                                            2
                                        )}
                                </Text>
                                <Image
                                    className="coin-tip-icon"
                                    src={require('../../images/cart-warning.png')}
                                    onClick={() => {
                                        coinRuleModal.current?.open()
                                    }}
                                ></Image>
                            </View>
                        )}
                        <Image
                            className="coin-check-icon"
                            src={require('../../images/cart-' +
                                (userCoin ? 'select' : 'unselect') +
                                '.png')}
                            onClick={() => {
                                setUserCoin(!userCoin)
                            }}
                        ></Image>
                    </Block>
                    {/*  <block wx:else>  */}
                    {/*  <view class="coin-item-line"><text>此商品无法使用金币折扣或不满足金币折扣条件</text></view>  */}
                    {/*  </block>  */}
                </View>
            )}
            {/*  发票  */}
            <View
                className="flex-conainer setting-style-item"
                style={{
                    display: 'none',
                }}
            >
                <Text className="flex-grow">发票类型</Text>
                <Text className="setting-style-des">不开发票</Text>
                <Image
                    className="setting-style-arrow"
                    src={require('../../images/right-arrow.png')}
                ></Image>
            </View>
        </View>
        {/*  确认支付信息  */}
        <View className="pay-info setting-style-pannel">
            <View className="flex-conainer setting-style-item">
                <Text className="flex-grow">商品总价</Text>
                <Text>{OrderTotals?.SubTotal}</Text>
            </View>
            {OrderTotals?.OrderTotalDiscount != null && (
                <View className="flex-conainer setting-style-item">
                    <Text className="flex-grow">优惠券</Text>
                    <Text className="setting-style-value">
                        {OrderTotals?.OrderTotalDiscount != null
                            ? OrderTotals?.OrderTotalDiscount
                            : '-¥0.00'}
                    </Text>
                </View>
            )}
            {OrderTotals?.RedeemedRewardPoints > 0 && (
                <View className="flex-conainer setting-style-item">
                    <Text className="flex-grow">金币抵扣</Text>
                    <Text className="setting-style-value">
                        {OrderTotals?.RedeemedRewardPointsAmount}
                    </Text>
                </View>
            )}
            {OrderTotals?.RequiresShipping && (
                <View className="flex-conainer setting-style-item">
                    <Text className="flex-grow">运费</Text>
                    <Text className="setting-style-value">
                        {OrderTotals?.Shipping ? OrderTotals?.Shipping : '+¥0'}
                    </Text>
                </View>
            )}
            <View className="flex-conainer setting-style-item">
                <Text className="flex-grow">实付款</Text>
                <Text className="setting-style-value">
                    {OrderTotals?.OrderTotal}
                </Text>
            </View>
            {RewardPoint?.DisplayHowMuchWillBeEarned && (
                <View className="confirm-point-container">
                    <View className="confirm-point-earn">
                        <Text>确认收货返</Text>
                        <Text className="confirm-point-earn-value">
                            {OrderTotals?.WillEarnRewardPoints + ' 金币'}
                        </Text>
                    </View>
                </View>
            )}

        </View>
        {/* <View className="pay-info setting-style-pannel">
            <View
                className="flex-conainer setting-style-item"
            // style={{
            //     display: 'none',
            // }}
            >
                <Text className="flex-grow">支付方式</Text>
                <View>
                    <Text>微信支付</Text>
                </View>
                <Image
                    className="setting-style-arrow"
                    src={require('../../images/right-arrow.png')}
                ></Image>
            </View>
        </View> */}
        {!tool.isEmpty(AddressError) ? (
            <View
                className={
                    'address-notice address-notice-error flex-conainer '
                }
            >
                {AddressError}
            </View>
        ) : (
            OrderTotals?.RequiresShipping &&
            ShippingAddress &&
            ShippingAddress?.Id > 0 && (
                <View
                    className={
                        'address-notice flex-conainer '
                    }
                >
                    {'配送至：' + tool.getFullAddress(ShippingAddress)}
                </View>
            )
        )}
        {/*  <view class="flex-conainer bottom-tool {{isIphoneX ? 'iphonex-page':''}}">
    
      <view class="flex-grow total-price">合计：<price value="{{OrderTotals.OrderTotal}}" size="32"></price></view>
    
      <view class="flex-fix buy-btn" bindtap='placeAndPayOrder'>提交订单</view>
    
    </view>  */}
        <View
            className={
                'padding-safe-area flex-conainer bottom-tool '
            }
        >
            <View className="flex-grow total-price">
                合计：<Price value={OrderTotals?.OrderTotal} size={32}></Price>
            </View>
            <PayOrderPanel
                ref={payOrderRef}>
                <Button
                    className={
                        'btn-clear-style  flex-fix buy-btn ' +
                        (!tool.isEmpty(AddressError) ? 'disable' : '')
                    }
                    type="default"
                    onClick={() => {
                        placeAndPayOrder()
                    }}

                >
                    提交订单
                </Button>
            </PayOrderPanel>

        </View>
        {/*  金币使用规则弹窗  */}
        <Modal
            ref={coinRuleModal}
        >
            <View className="modal-title">金币使用规则</View>
            {RewardPoint?.Rules?.map((item, index) => {
                return (
                    <View key={item.Title} className="modal-section">
                        <Text className="modal-section-tile">{item.Title}</Text>
                        {item.Items.map((line: any) => {
                            return (
                                <Text key={line.line} className="modal-section-des">
                                    {line}
                                </Text>
                            )
                        })}
                    </View>
                )
            })}
            <View
                className="modal-confirm-btn"
                onClick={() => {
                    coinRuleModal.current?.close()
                }}
            >
                知道了
            </View>
        </Modal>
    </View>
}

export default Checkout;
